exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".astranaut-bg[data-v-857c33d0]{margin:auto -72px;background-image:url(/assets/img/astranaut.svg);height:70%;background-position:top;background-size:auto;background-repeat-y:no-repeat}", ""]);

// exports
